export { default } from './InvitationSuccess';
